import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import gearsAnimation from '../animations/gears-white.json';
import './Loader.css';
import logo from '../assets/hilal-makine.png'; // Logo import

function Loader({ onFinish }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      if (onFinish) onFinish();
    }, 2000); // 2 saniye

    return () => clearTimeout(timer);
  }, [onFinish]);

  if (!visible) return null;

  return (
    <div className="loader-overlay">
      <img src={logo} alt="Hilal Makina" className="loader-logo" />
      <Lottie animationData={gearsAnimation} loop={true} style={{ width: 120, height: 120 }} />
    </div>
  );
}

export default Loader;
